export const constant = {
  New_Report: 'New Report',
  Report_Name: 'Report Name',
  Report_Type: 'Report Type'
};
